export const CONTENT_LOOKUP_KEY = 'LOOKUPKEY';
/**
 * @deprecated This and all references will be removed
 */
export const CAMPAIGN_TAG = 'CAMPAIGN';
